import { createContext } from 'react';

import { SupplierSubscriptionPlan } from '../../types/SupplierGroupSubscriptionMessage';

interface SupplierSubscriptionPlansContextValue {
    currentPlan: SupplierSubscriptionPlan | undefined;
    canViewPlans: boolean;
    isFeeEnforced: boolean;
    openPlans: () => void;
}

export const SupplierSubscriptionPlansContext = createContext<SupplierSubscriptionPlansContextValue | null>(null);
